// extracted by mini-css-extract-plugin
module.exports = {"card":"plain-card_card__3SvSn","secondary":"plain-card_secondary__Ztvei"};